import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCandidates = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 27,
	height: 28,
	viewBox: "0 0 27 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .75,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M10.1665 12.5286C10.0718 12.5192 9.95826 12.5192 9.85415 12.5286C7.60143 12.4535 5.8125 10.6234 5.8125 8.37092C5.8125 6.11845 7.68661 4.20386 10.0151 4.20386C12.3435 4.20386 14.2176 6.07153 14.2176 8.37092C14.2081 10.6234 12.4192 12.4535 10.1665 12.5286Z",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.42301 15.9917C3.13243 17.5122 3.13243 19.9899 5.42301 21.5009C8.02595 23.2278 12.2948 23.2278 14.8977 21.5009C17.1883 19.9805 17.1883 17.5028 14.8977 15.9917C12.3042 14.2742 8.03541 14.2742 5.42301 15.9917Z",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.0054 12.0312C17.1001 12.0312 17.1947 12.0312 17.2799 12.0312C19.2676 11.9655 20.8388 10.3512 20.8483 8.37093C20.8483 6.34372 19.1919 4.70129 17.1474 4.70129C16.8161 4.70129 16.5038 4.75761 16.1914 4.84207",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.707 22.5803C19.501 22.5803 20.6007 22.0865 21.501 21.5C23.7916 20.0077 23.8594 17.4465 21.5688 15.9636C20.5651 15.2316 19.501 15 17.8679 14.7623",
				stroke: "black",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgCandidates;
